export default function replaceHtmlBreakWithNewLine(html: string) {
  return html.replace(/<br\s*[/]?>/gi, '\n')
}
